import { Component, Injector, ViewChild } from '@angular/core';
import { BaseFormComponent } from '../base-form.component';
import { TextAutoCompleteDropDownComponent } from '../text-autocomplete-dropdown/text-autocomplete-dropdown.component';

@Component({
  moduleId: module.id,
  selector: 'place-of-birth',
  templateUrl: './place-of-birth.component.html',
})
export class PlaceOfBirthComponent extends BaseFormComponent {
  levelClass: string;
  statePropertyName: string;
  countryPropertyName: string;
  showStateField: boolean;
  @ViewChild('stateRef', { static: true }) stateComponent: TextAutoCompleteDropDownComponent;

  constructor(protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.levelClass = this.getLevelClass();
    this.countryPropertyName = this.getCustomProp(0);
    this.showStateField = this.getValue(this.countryPropertyName) === 'US';
    this.statePropertyName = this.getCustomProp(1);
  }

  updateFromModel() {}

  countryChangedTrigger(countryVal: string) {
    if (countryVal === 'US') {
      this.showStateField = true;
    } else {
      /**
       * country != US so hide state field and
       * set value to null (if it currently has a value)
       */
      this.showStateField = false;
      if (this.getValue(this.statePropertyName)) {
        this.setValue(this.statePropertyName, null);
        this.stateComponent.resetValue();
      }
    }
  }
}
